module.exports = __webpack_public_path__ + "static/frank-campanella-lg-685dd804aeac19d8a1130d5a4a981dbc.png";